<template>
  <div :class="{ 'd-flex': horizontal }">
    <div
      v-for="item in options"
      :key="item.id"
      :class="{ 'mt-1 mr-4': horizontal, 'mt-3': !horizontal }"
    >
      <check-box
        class="custom-checkbox fs-lg"
        :disabled="isReadOnly"
        :text="item.name"
        :value="checkeds.includes(item.id)"
        @input="(val) => onCheck(val, item)"
      />
    </div>
  </div>
</template>

<script>
import CheckBox from 'CheckBox';
export default {
  name: 'RubricPreviewQuestionCheck',
  components: {
    CheckBox,
  },
  props: {
    value: {
      type: Array,
      default: () => null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    horizontal: {
      type: Boolean,
      default: () => false,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    checkeds() {
      return this.value?.map((x) => x.id) ?? [];
    },
  },
  methods: {
    onCheck(val, answer) {
      const answers = this.value || [];
      if (val) answers.push(answer);
      else {
        const index = this.value.findIndex((x) => x.id === answer.id);
        this.value.splice(index, 1);
      }
      this.$emit('input', answers);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-checkbox ::v-deep label > span {
  margin-top: 5px !important;
}
.fs-lg {
  font-size: 1.25rem;
  line-height: 1.5;
}
</style>
